import { contentUrl } from '../api'

const url = `${contentUrl}/print`

export const PRINT = {
  name: 'PRINT',
  title: 'PRINT',
  mobileType: "mobile",
  content: [
    {
      menuTemplate: 'SINGLE',
      menuName: 'Option 1',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${url}/option-1.png`, alt: "Option 1 - Print" }],
          mobileImageList: [{ srcMobile: `${url}/option-1.png`, alt: "Option 1 - Print" }],
        },
      }
    },
    {
      menuTemplate: 'SINGLE',
      menuName: 'Option 2',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${url}/option-2.png`, alt: "Option 2 - Print" }],
          mobileImageList: [{ srcMobile: `${url}/option-2.png`, alt: "Option 2 - Print" }],
        },
      }
    },
  ],
}
